import {Injectable, Inject} from '@angular/core';
import {PLATFORM_ID} from '@angular/core';

// 全局变量，服务器渲染不能用浏览器里的 window对象。
// 此文件用来代替在服务器上使用 localStorage。

@Injectable({
  providedIn: 'root'
})
export class GlobalCacheService {
  constructor(
    @Inject(PLATFORM_ID) private platformId,
  ) {
  }

  public appId: string;
  public templateDataMap: object;
  public classifyContentsMap: object;
  public classificationListData: object;
  public pageAttribute: object = {};
  public article: object = {};
  public menuList: Array<any> = [];
  public merchant;
  public language = '';
  public login = null;
  public userInfo = {};
  public navigation: any = {}; // 面包屑
}
